import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputAdornment, TextField } from '@mui/material';

export default function InputAdornments({
  onChange,
  onKeyPress,
  error,
  disabled,
  value,
  autoFocus,
  inputRef
}) {
  return (
    <TextField
      fullWidth
      id={'outlined-adornment-email'}
      name='email'
      label='Email'
      value={value}
      error={error}
      helperText={error}
      onChange={onChange}
      onKeyPress={onKeyPress}
      disabled={disabled}
      autoFocus={autoFocus}
      inputRef={inputRef}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <div className='p-2' aria-label='enter email'>
              <FontAwesomeIcon icon='envelope' />
            </div>
          </InputAdornment>
        )
      }}
    />
  );
}
